/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFall = createReactComponent("fall", "IconFall", [
  ["path", { d: "M11 21l1 -5l-1 -4l-3 -4h4l3 -3", key: "svg-0" }],
  ["path", { d: "M6 16l-1 -4l3 -4", key: "svg-1" }],
  ["path", { d: "M6 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-2" }],
  ["path", { d: "M13.5 12h2.5l4 2", key: "svg-3" }]
]);

export { IconFall as default };
//# sourceMappingURL=IconFall.js.map
